const router = [
    {
        path: '/self-service',
        name: 'selfService',
        redirect: '/self-service/configuration',
        component: () => import('@/modules/SelfService/pages'),
        children: [
            {
                path: '/self-service/configuration',
                name: 'SelfServiceConfiguration',
                component: () => import('@/modules/SelfService/pages/SelfServiceConfiguration'),
                meta: {
                    requiresAuth: true,
                    requiresPermission: true,
                    action: 200
                }
            },
        ],
        meta: {
            requiresAuth: true,
            requiresPermission: true,
            action: 7
        }
    }
]
export default router